export default "__VITE_ASSET__DEZ6SHnA__"